<template>
    <div class="faqCatCard border-bottom bg-white">
    <div
      class="p-3 d-flex flex-row" :class="selected.id == category.id? 'selectedCategory' : 'bg-white'"
      @click="selectCat(category)">

      <div class="me-2">
        <i class="fa-fw" :class="category.acf.icon"></i>
      </div>
      <span v-html="category.name"></span>
    </div>
  </div>

</template>
 
<script>

export default {

    props: { category: { type: Object }, selectCat: { type: Function }, selected: {type: Object} },
}
</script>